import { Collapse } from '@material-ui/core';
import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { toggleLikeBackstage } from 'APIs/BackstageApi';
import { CommentType } from 'APIs/BackstageCommentApi';
import { useAppSelector } from 'app/hooks';
import LikeButton from 'components/atoms/Button/LikeButton';
import StatusButton from 'components/atoms/Button/StatusButton';
import CommentInput from 'components/atoms/Inputs/CommentInput';
import MultiMediaDisplay from 'components/molecules/MultiMediaDisplay';
import { selectAuth } from 'features/auth/authSlice';
import Backstage from 'interfaces/Backstage.interface';
import BackstageComment from 'interfaces/BackstageComment.interface';
import { UserData } from 'interfaces/UserData.interface';
import * as React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import CardCommentListsWithData from '../CardCommentListsWithData';
import DeleteIcon from '@mui/icons-material/Delete';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { NormalButton } from 'components/atoms/Button';
import { checkSub, handleToggleSubscribe } from 'APIs/utils';
import { useDispatch } from 'react-redux';
import Badge from 'components/atoms/Badge';
import PurchaseContentModal from 'components/molecules/PurchaseContentModal';
import BackstagePrompt from 'views/DesktopViews/OtherProfilePage/ProfilePageBody/BackstagePrompt';
import moment from 'moment';

const TitleSectionContent = styled(CardContent)(({ theme }) => ({
  padding: 'unset',
  paddingLeft: '16px',
}));

const HeadSectionContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '11px',
  width: '100%',
}));

const FooterSectionContent = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexWrap: 'wrap',
  padding: 'unset',

  paddingLeft: '16px',
  paddingRight: '16px',
}));

const FooterSectionContent1 = styled(CardContent)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'start',
  alignItems: 'center',
  gap: '15px',
  padding: 'unset',
}));

const HeadSectionSubBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'start',
  gap: '5px',
  width: '100%',
}));

const ContentText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  padding: '0px 0px 20px 0px',
  // fontWeight: "bold",
}));

const NameText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#ffffff',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  width: 'fit-content',
  alignItems: 'center',
}));

const TimeText = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  color: '#bcbcbc',
}));

const InsideCommetContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '14px',
  paddingRight: '40px',
  paddingLeft: '40px',
  marginBottom: '20px',
  marginTop: '15px',
}));

const ContentOverlay = styled(Box)(({ theme }) => ({
  position: 'absolute',
  width: '100%',
  height: '550px',
  backgroundColor: 'rgba(221, 185, 48,0.6)',
  zIndex: 99,
  backdropFilter: 'blur(20px)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

const CommentTitleText = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#c1c1c1',
  fontWeight: 'bold',
}));

const InsideBottomContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: '10px',
}));

const UnlockContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  margin: '25px 10px',
  padding: '8px 20px',
  borderRadius: '10px',
  backgroundColor: 'rgba(221, 185, 48,0.6)',
  color: 'white',
  justifyContent: 'space-between',
}));

interface IProfileOtherPostCardWithData {
  data: Backstage;
}

const ProfileOtherPostCardWithData: React.FC<IProfileOtherPostCardWithData> = ({
  data,
}) => {
  const navigate = useNavigate();
  const authState = useAppSelector(selectAuth);
  const location = useLocation();
  const avatar1 = require('assets/Profile/buku_default_avatar.png');

  const [liked, setLiked] = React.useState(false);
  const [numOfLikes, setNumOfLikes] = React.useState<number>(0);
  const [deleted, setDeleted] = React.useState<boolean>(false);
  const [loading, setLoading] = React.useState(false);
  const [expanded2, setExpanded2] = React.useState(false);
  const [transaction, setTransaction] = React.useState<boolean>(false);
  const [, setError] = React.useState<string>('');
  const [isPosted, setIsPosted] = React.useState<boolean>(false);
  const [subLoading, setSubLoading] = React.useState<boolean>(false);
  const [subscribed, setSubscribed] = React.useState<boolean>(false);
  const [isSubscribed, setIsSubscribed] = React.useState<boolean>(false);
  const dispatch = useDispatch();

  const handleExpand2Click = () => {
    setExpanded2(!expanded2);
  };

  const handleToggleLike = async () => {
    setLoading(true);
    const likedState = liked;
    setNumOfLikes(likedState ? numOfLikes - 1 : numOfLikes + 1);
    setLiked(!likedState);
    try {
      await toggleLikeBackstage(data.id, authState.id, data.user?.id);
    } catch (error) {
      setNumOfLikes(data.likedBy?.length || 0);
      setLiked(likedState);
    }
    setLoading(false);
  };

  React.useEffect(() => {
    if (authState?.id) {
      const found = data.likedBy?.includes(authState.id);
      setLiked(!!found);
    }
    setNumOfLikes(data.likedBy?.length || 0);
  }, [data, authState]);

  const addComment = (comment: BackstageComment, id: string) => {
    const newComment = {
      ...comment,
      id,
      user: authState as UserData,
      createdDate: new Date().getTime(),
      updatedDate: new Date().getTime(),
    };
    if (comment.parent) {
      const parentIndex = data.comments.findIndex(item => {
        if (comment.parent) return item.id === comment.parent.id;
        else return false;
      });
      if (!data.comments[parentIndex].children) {
        data.comments[parentIndex].children = [];
      }
      data.comments[parentIndex].children = [
        ...(data.comments[parentIndex].children || []),
        newComment,
      ];
    } else data.comments = [...data.comments, newComment];
    setIsPosted(!isPosted);
  };

  const isBought = React.useCallback(() => {
    if (data.user && authState.id) {
      return (
        data.user.username === authState.username ||
        data.usersWithAccess?.includes(authState.id) ||
        subscribed
      );
    }
  }, [authState.id, data, subscribed, authState.username]);

  React.useEffect(() => {
    !isBought() &&
      checkSub(
        setSubLoading,
        authState,
        setSubscribed,
        setIsSubscribed,
        setTransaction,
        dispatch,
        data.user,
        true,
        undefined,
        data
      );

    //eslint-disable-next-line
  }, [
    authState.id,
    data?.user,
    authState.transactionsReceived,
    data,
    isBought,
  ]);

  React.useEffect(() => {
    const postId = parseInt(location.search.split('postId=')[1]);
    if (authState.id && data.id === postId && authState.id !== data.user?.id)
      handleToggleSubscribe(
        authState,
        setError,
        setTransaction,
        setLoading,
        setIsSubscribed,
        dispatch,
        true,
        data.price,
        data.user,
        data
      );
    //eslint-disable-next-line
  }, [authState.id, data.id]);

  return (
    <>
      <Card
        sx={{
          width: '100%',
          minWidth: '300px',
          maxWidth: '850px',
          backgroundColor: 'rgba(255,255,255,0.09803921568627451 )',
          boxShadow: 'unset',
          borderRadius: '20px',
          marginTop: '16px',
          display: deleted ? 'none' : 'block',
          position: 'relative',
        }}
      >
        <HeadSectionContent>
          <img
            src={data.user?.avatar ? data.user?.avatar : avatar1}
            alt="avatar"
            width="50px"
            height="50px"
            style={{
              borderRadius: '50%',
              objectFit: 'cover',
            }}
            draggable="false"
          />

          <HeadSectionSubBox>
            <NameText>
              <span
                onClick={() => navigate(`/profile/${data.user?.username}/`)}
              >
                @{data.user?.username}
              </span>
            </NameText>
            <TimeText>{moment(data.createdDate).fromNow()}</TimeText>
          </HeadSectionSubBox>
          {data.user &&
            authState &&
            authState.username === data.user.username && (
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  marginRight: '25px',
                }}
              >
                <IconButton onClick={() => setDeleted(true)}>
                  <DeleteIcon sx={{ color: 'white', opacity: '0.5' }} />
                </IconButton>
              </div>
            )}
        </HeadSectionContent>
        <TitleSectionContent>
          <ContentText>
            {data.content}
            {data.isPremium && <Badge />}
            {data.isPremium && (
              <h5
                style={{
                  fontStyle: 'italic',
                  opacity: '0.7',
                  marginTop: '20px',
                }}
              >
                This post contains pay-per-view content
              </h5>
            )}
          </ContentText>
        </TitleSectionContent>
        {data.isPremium &&
          !isBought() &&
          (data.videos?.length > 0 || data.images?.length > 0) && (
            <ContentOverlay>
              <IconButton
                sx={{
                  backgroundColor: 'rgba(0,0,0,0.3)',
                  padding: '20px',
                  borderRadius: '50%',
                  color: 'white',
                  opacity: '0.7',
                }}
              >
                <LockOutlinedIcon fontSize="large" />
              </IconButton>
            </ContentOverlay>
          )}
        {(data.videos?.length > 0 || data.images?.length > 0) && (
          <MultiMediaDisplay images={data.images} videos={data.videos} />
        )}
        <FooterSectionContent>
          {data.isPremium &&
            !isBought() &&
            (data.videos?.length > 0 || data.images?.length > 0) && (
              <UnlockContent>
                <span
                  style={{ display: 'flex', alignItems: 'center', gap: '5px' }}
                >
                  <LockOutlinedIcon fontSize="small" />
                  You can unlock and view this content for ${data.price}.
                </span>
                <PurchaseContentModal
                  isSubscribed={isSubscribed}
                  loading={loading}
                  setError={setError}
                  setIsSubscribed={setIsSubscribed}
                  setLoading={setLoading}
                  setSubscribed={setSubscribed}
                  setTransaction={setTransaction}
                  transaction={transaction}
                  data={data}
                  subLoading={subLoading}
                >
                  <NormalButton
                    sx={{ padding: '5px 15px', borderRadius: '10px' }}
                    text={'Unlock'}
                    color="yellow"
                  />
                </PurchaseContentModal>
              </UnlockContent>
            )}
          <div style={{ position: 'absolute' }}>
            <BackstagePrompt
              isPost={true}
              transaction={transaction}
              loading={loading}
            >
              <></>
            </BackstagePrompt>
          </div>
          {/* <Stack
            direction={'column'}
            spacing={2}
            sx={{ width: '100%', marginTop: '10px ' }}
          >
            {transaction && (
              <Alert onClose={() => setTransaction(false)} severity="success">
                Thanks for supporting {data?.user?.username}! We're waiting for
                the blockchain to finish confirming the transaction before we
                can unlock the content for you. Please check back in about 15
                minutes!
              </Alert>
            )}
            {error && (
              <Alert onClose={() => setError('')} severity="error">
                There was an error in unlocking content of{' '}
                {data?.user?.username} : {error.split('(')[0]}
              </Alert>
            )}
          </Stack> */}
          <FooterSectionContent1>
            <LikeButton
              text={`${numOfLikes}`}
              checked={liked}
              onClick={() => !loading && handleToggleLike()}
            />
            <Box onClick={handleExpand2Click}>
              <StatusButton type={'none'} text={`${data.comments?.length}`} />
            </Box>
            <StatusButton type={'money'} text={'0'} />
          </FooterSectionContent1>
          <Box
            sx={{
              color: '#ffffff',
              borderRadius: '20px',
              borderColor: '#ffffff',
              borderStyle: 'solid',
              fontSize: '8px',
              padding: '3px',
              paddingRight: '6px',
              paddingLeft: '6px',
              borderWidth: '1px',
            }}
          >
            $ TIP
          </Box>
        </FooterSectionContent>
        <Collapse in={expanded2} timeout="auto" unmountOnExit>
          <InsideCommetContent>
            <CommentTitleText onClick={handleExpand2Click}>
              Hide Comments
            </CommentTitleText>
            {data.comments &&
              data.comments
                .filter(item => !item.parent)
                .map((item, index) => {
                  return (
                    <CardCommentListsWithData
                      key={item.id}
                      data={item}
                      addComment={addComment}
                      type={CommentType.BACKSTAGE}
                    />
                  );
                })}
            <InsideBottomContent>
              <CommentInput
                ownerId={data.user && data.user.id}
                type={CommentType.BACKSTAGE}
                postId={`${data.id}`}
                addComment={addComment}
              />
            </InsideBottomContent>
            {/* <ToggleContent>
              <GhostModeText>Ghost mode</GhostModeText>
              <AntSwitch
                defaultChecked
                inputProps={{ "aria-label": "ant design" }}
              />
            </ToggleContent> */}
          </InsideCommetContent>
        </Collapse>
      </Card>
    </>
  );
};

export default ProfileOtherPostCardWithData;
